<template>
    <div class="tarea-editar">
      <header class="header">
        <h1>Editar Tarea</h1>
      </header>
      <form @submit.prevent="updateTask">
        <!-- Título -->
        <div class="form-group">
          <label for="titulo">Título:</label>
          <input type="text" id="titulo" v-model="taskData.titulo" required />
        </div>
        <!-- Descripción -->
        <div class="form-group">
          <label for="descripcion">Descripción:</label>
          <textarea id="descripcion" v-model="taskData.descripcion"></textarea>
        </div>
        <!-- Es Recurrente -->
        <div class="form-group checkbox-group">
          <label>
            <input type="checkbox" v-model="taskData.es_recurrente" />
            Es Recurrente
          </label>
        </div>
        <!-- Campo para tareas recurrentes -->
        <div class="form-group" v-if="taskData.es_recurrente">
          <label for="dia_semana">Día de la semana:</label>
          <select id="dia_semana" v-model="taskData.dia_semana" required>
            <option v-for="(dia, index) in diasSemana" :key="index" :value="index">
              {{ dia }}
            </option>
          </select>
        </div>
        <!-- Campo para tareas no recurrentes -->
        <div class="form-group" v-else>
          <label for="fecha">Fecha:</label>
          <input type="date" id="fecha" v-model="taskData.fecha" required />
        </div>
        <!-- Estado -->
        <div class="form-group">
          <label for="estado">Estado:</label>
          <select id="estado" v-model="taskData.estado">
            <option value="PENDIENTE">Pendiente</option>
            <option value="COMPLETADA">Completada</option>
            <option value="CANCELADA">Cancelada</option>
          </select>
        </div>
        <!-- Personal -->
        <div class="form-group">
          <label for="personal_id">Personal:</label>
          <select id="personal_id" v-model="taskData.personal_id">
            <option :value="null">Sin asignar</option>
            <option v-for="personal in personalList" :key="personal.id" :value="personal.id">
                {{ personal.legajo }} - {{ personal.nombre }} {{ personal.apellido }} - {{ personal.rol }} - {{ personal.estado }}
            </option>
          </select>
        </div>
        <!-- Botonera -->
        <div class="form-actions">
          <button type="submit" class="btn btn-submit">Actualizar Tarea</button>
          <button type="button" class="btn btn-cancel" @click="cancelEdit">Cancelar</button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  
  export default {
    name: 'TareaEditar',
    props: {
      taskId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        taskData: {
          id: null,
          titulo: '',
          descripcion: '',
          fecha: '',
          dia_semana: 0,
          es_recurrente: false,
          estado: 'PENDIENTE',
          personal_id: null
        },
        diasSemana: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        personalList: [] // Se obtiene desde la API
      };
    },
    methods: {
      async fetchTask() {
        try {
            const club_id = this.$store.getters.getClubActual.id;

          const response = await axios.get(`/api/libreta_tarea/${this.taskId}`, {params:{club_id}});
          const task = response.data;
          // Si la tarea no es recurrente y tiene fecha, formateamos la fecha para el input
          if (!task.es_recurrente && task.fecha) {
            task.fecha = this.formatDateForInput(task.fecha);
          }
          this.taskData = { ...task };
        } catch (error) {
          console.error('Error al obtener la tarea:', error);
          alert('Error al cargar la tarea.');
        }
      },
      async fetchPersonalList() {
        try {
            const club_id=this.$store.getters.getClubActual.id;
          const { data } = await axios.get('/api/personal', {params:{club_id}});
          this.personalList = data;
        } catch (error) {
          console.error('Error al obtener el personal:', error);
        }
      },
      async updateTask() {
        // Validaciones
        if (this.taskData.es_recurrente && (this.taskData.dia_semana === null || this.taskData.dia_semana < 0 || this.taskData.dia_semana > 6)) {
          alert('Seleccione un día de la semana válido para la tarea recurrente.');
          return;
        }
        if (!this.taskData.es_recurrente && !this.taskData.fecha) {
          alert('Seleccione una fecha para la tarea.');
          return;
        }
        const dataToUpdate = {
          ...this.taskData,
          fecha: this.taskData.es_recurrente ? null : this.taskData.fecha,
          dia_semana: this.taskData.es_recurrente ? this.taskData.dia_semana : null
        };
        try {
            const club_id = this.$store.getters.getClubActual.id;

          await axios.put(`/api/libreta_tarea/${this.taskId}`, dataToUpdate,{params:{club_id}});
          alert('Tarea actualizada correctamente.');
          this.$emit('updated'); // Para que el padre sepa que se actualizó la tarea
        } catch (error) {
          console.error('Error al actualizar la tarea:', error);
          alert(error.response?.data?.error || 'Error al actualizar la tarea.');
        }
      },
      cancelEdit() {
        this.$emit('cancel');
      },
      formatDateForInput(dateStr) {
        try {
          const date = new Date(dateStr);
          return date.toISOString().split('T')[0];
        } catch (e) {
          console.error('Error al formatear fecha para input:', e);
          return '';
        }
      }
    },
    created() {
      this.fetchTask();
      this.fetchPersonalList();
    }
  };
  </script>
  
  <style scoped>
  .tarea-editar {
    max-width: 600px;
    margin: 20px auto;
    padding: 20px;
    background-color: #f7f7f7;
    border-radius: 8px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
  .header {
    text-align: center;
    margin-bottom: 20px;
  }
  .header h1 {
    font-size: 2rem;
    margin: 0;
  }
  form {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
  .form-group {
    margin-bottom: 15px;
  }
  .form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
  }
  .form-group input[type="text"],
  .form-group input[type="date"],
  .form-group textarea,
  .form-group select {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .checkbox-group {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 500;
  }
  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.2s ease;
  }
  .btn-submit {
    background-color: #28a745;
    color: #fff;
  }
  .btn-submit:hover {
    background-color: #218838;
  }
  .btn-cancel {
    background-color: #dc3545;
    color: #fff;
  }
  .btn-cancel:hover {
    background-color: #c82333;
  }
  </style>
  